import React from 'react';
import { Grid, Modal } from '~/components';
import { MdClose, MdFileDownload } from 'react-icons/md';
import { useOrderHistory } from './context';
import { document as doc } from '~/api';
import { sortStrings } from '~/util/sorters';
const { DocumentTypeNames } = doc;


const AttachmentsModal = ({ isOpen }) => {
    const { hideAttachmentsModal, setAttachments } = useOrderHistory();

    const handleClose = () => {
        setAttachments([]);
        hideAttachmentsModal();
    };


    return (
        <Modal isModalOpen={isOpen} preventScroll className='rounded-md bg-white w-3/4'>
            <section className='w-full h-full flex flex-col items-stretch justify-start'>
                <header className="border-b-2 text-sm flex items-center justify-between py-2 px-6">
                    <p className="font-semibold">Attachments</p>
                    <button 
                        className="py-2 rounded-full"
                        onClick={() => handleClose()}
                    >
                        <MdClose size="1em" />
                    </button>
                </header>
                <div className='flex flex-col items-center justify-center flex-1 p-6'>
                    <DocumentGrid />
                </div>
            </section>
        </Modal>
    );
};

export default AttachmentsModal;

const headerClassName = 'bg-gray-50 p-2 border-b text-left';
const props = {
    className: 'p-2 text-sm border-b'
};

const columns =  [
    {
        title: 'File Name',
        field: 'name',
        headerClassName,
        props
    },
    {
        title: 'Type',
        cell: DocType,
        sorter: (a,b) => sortStrings(DocumentTypeNames[a.typeId], DocumentTypeNames[b.typeId]),
        headerClassName,
        props
    },
    {
        title: '',
        key: 'download',
        canSort: false,
        cell: DownloadButton,
        headerClassName,
        props: {
            className: 'text-sm border-b hover:bg-primary-10'
        }
    }
];

function DocumentGrid() {
    const { attachments } = useOrderHistory();

    return (
        <Grid 
            className='w-3/4 text-sm text-neutral-90 mb-2'
            data={attachments}
            columns={columns}
            usePagination={false}
        />
    );
}


function DocType({ data }) {
    const { typeId } = data;

    let name = DocumentTypeNames[typeId];
   
    if (name == undefined)
        name = '';

    return <>{name}</>;
}
function DownloadButton({ data }) {
    return (
        <button 
            className='flex items-center justify-center w-full focus:outline-none'
            onClick={() => doc.download(data)}
        >
            <MdFileDownload size='1.25rem'/>
        </button>
    );
}
